import type { Language } from "@/lib/i18n/types"
import type { UseCaseData } from "./use-cases-registry"
import { useCases } from "./use-cases-registry"

// Import translations — each file exports the same 4 use cases with translated text
// slug, icon, color, seo, relatedSlugs stay identical across languages
import { useCasesEs } from "./translations/es"
import { useCasesFr } from "./translations/fr"
import { useCasesDe } from "./translations/de"
import { useCasesIt } from "./translations/it"
import { useCasesPt } from "./translations/pt"
import { useCasesTr } from "./translations/tr"

const registry: Record<Language, UseCaseData[]> = {
  en: useCases,
  es: useCasesEs,
  fr: useCasesFr,
  de: useCasesDe,
  it: useCasesIt,
  pt: useCasesPt,
  tr: useCasesTr,
}

export function getUseCasesForLanguage(lang: Language): UseCaseData[] {
  return registry[lang] || useCases
}

export function getUseCaseBySlugForLanguage(lang: Language, slug: string): UseCaseData | undefined {
  const cases = getUseCasesForLanguage(lang)
  return cases.find((uc) => uc.slug === slug)
}

export function getRelatedUseCasesForLanguage(lang: Language, slug: string): UseCaseData[] {
  const cases = getUseCasesForLanguage(lang)
  const useCase = cases.find((uc) => uc.slug === slug)
  if (!useCase) return []
  return useCase.relatedSlugs
    .map((s) => cases.find((uc) => uc.slug === s))
    .filter((uc): uc is UseCaseData => uc !== undefined)
}
